import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";

import { buttonVariants } from "@acme/ui/button";

export const Error404 = () => {
  const { t } = useTranslation();
  return (
    <div className="flex h-[70vh] flex-col items-center justify-center gap-6">
      <div className="bg-background mx-4 max-w-md rounded-lg border p-8 pb-6 text-center">
        <h2
          id="error-title"
          className="text-foreground mb-4 text-xl font-semibold tracking-tight"
        >
          404 - {t("Page Not Found")}
        </h2>
        <p className="text-foreground/60 text-sm leading-6">
          {t(
            "The page you are looking for might have been removed, had its name changed, or is temporarily unavailable.",
          )}
        </p>
        <p className="text-foreground mt-4 text-sm leading-6">
          <a
            className="cursor-pointer underline decoration-from-font underline-offset-2 hover:opacity-80"
            rel="ugc"
            href="mailto:alexandre@godard.me"
          >
            {t("Share your feedback")}
          </a>
        </p>
        <p className="text-muted-foreground mt-6 font-[menlo] text-[10px]">
          (aP2ibV8Zotj)
        </p>
      </div>
      <Link
        className={buttonVariants({ variant: "default" })}
        to="/"
        prefetch="render"
      >
        {t("Go back home")}
      </Link>
    </div>
  );
};
